<template>
  <v-app>
    <v-app-bar app color="#F5F5F5" height="100">
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="./assets/NUS_logo.png"
          transition="scale-transition"
          width="150"
        />
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <MainContent />
    </v-main>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import MainContent from "./components/MainContent";

export default {
  name: "App",

  components: {
    MainContent,
  },

  data: () => ({
    //
  }),
};
</script>
